/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./sort-tree.vue?vue&type=template&id=27228ce2&scoped=true&"
import script from "./sort-tree.vue?vue&type=script&lang=js&"
export * from "./sort-tree.vue?vue&type=script&lang=js&"
import style0 from "./sort-tree.vue?vue&type=style&index=0&id=27228ce2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27228ce2",
  null
  
)

export default component.exports